module.exports = __webpack_public_path__ + "img/progress-2.1ff5b886.png";